import { useState } from "react";
import FirstTab from "./AllTabs/FirstTab";
import SecondTab from "./AllTabs/SecondTab";
import Download from "./Download";
import Upload from "./Upload";

const Tabs = ({initialPokedex}) => {
  const [pokedex, setPokedex] = useState(initialPokedex);
  function handleUserData(newdex) {
    localStorage.setItem("pokedex", newdex);
    setPokedex(JSON.parse(newdex));
  }

  const [tab, setTab] = useState("tab1");
  const handleClick = id => {
    setTab(id);
  };
  return (
    <>      <Download pokedex={pokedex} /><br/>
    <Upload userData={handleUserData}/>
    <div className="ui container">
      <div className="ui top attached tabular menu">
        <a
          className={tab === "tab1" ? "nav link item active" : "nav link item"}
          id="tab1"
          data-tab="first"
          onClick={e => handleClick(e.target.id)}
        >
          Not Caught
        </a>
        <a
          className={tab === "tab2" ? "nav link item active" : "nav link item"}
          id="tab2"
          data-tab="second"
          onClick={e => handleClick(e.target.id)}
        >
          Caught
        </a>
      </div>
      <div
        className="ui bottom attached active tab segment"
        data-tab={tab === "tab1" ? "first" : "second"}
      >
        {tab === "tab1"
          ? <FirstTab data={pokedex} />
          : <SecondTab data={pokedex} />}
      </div>
    </div>
    </>
  );
};

export default Tabs;
